module.exports = __webpack_public_path__ + "static/media/finekralogo.1e3083b2.png";